/**
 * Device API Functions
 * デバイス関連のAPI操作
 */

import { tenantDevices, deviceDisplayNames } from '@/LantanaAPI/graphql/queries';
import { createDocsInsightsReport } from '@/LantanaAPI/graphql/mutations';

import { executeQuery, executeMutation } from '../core/client';

/**
 * デバイスの表示名を表す型です。
 */
export type DeviceDisplayName = {
    serialIdAndDisplayNameMappings: { serialId: string; displayName: string; }[];
};

/**
 * テナントのデバイス一覧を取得
 */
export async function getTenantDevices(): Promise<{ deviceId: string; serialId: string; }[]> {
    const result = await executeQuery(tenantDevices);
    return result.tenantDevices ?? [];
}

/**
 * デバイスの表示名一覧を取得
 */
export async function getDeviceDisplayNames(): Promise<DeviceDisplayName> {
    const result = await executeQuery(deviceDisplayNames);
    return result.getDeviceDisplayNames as DeviceDisplayName ?? { serialIdAndDisplayNameMappings: [] };
}

/**
 * ドキュメントインサイトレポートを作成
 */
export async function createDocumentsInsightsReport(input: any) {
    return executeMutation(createDocsInsightsReport, { input });
}
